<div bsModal #editDepositModal="bs-modal" [config]="modalConfig" class="modal fade" id="EditDeposit" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Deposit</h5>
        <button type="button" class="close" aria-label="Close" (click)="onCancel(); closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            @if (depositType == eDepositType.Fixed) {
              <div>
                <label>Deposit</label>
                <input type="text" class="form-control" [(ngModel)]="currentDeposit"
                  [appTwoDigitDecimal]="costValueDirectiveSetting" [disabled]="!editRightDeposit"/>
                </div>
              }
              @if (depositType == eDepositType.Percentage) {
                <div>
                  <div class="row">
                    <div class="col-md-6">
                      <label>Deposit Percentage</label>
                      <input type="text" class="form-control" [(ngModel)]="depositPercentage"
                        (percentageDebounce)="keyUpDeposit($event)" (blur)="formatPercentage()" [disabled]="!editRightDeposit"/>
                      </div>
                      <div class="col-md-6 pt-3 pt-md-0">
                        <label>Deposit Value</label>
                        <input type="text" class="form-control" [(ngModel)]="currentDeposit" disabled/>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="row mx-0 mt-3">
              <label class="ps-0">
                Note
                @if (isNoteRequired()) {
                  <span
                  class="required">*</span>
                }
              </label>
              <textarea rows="5" class="form-control" [(ngModel)]="depositNote" #noteField="ngModel" appRestrictHtmltagchars></textarea>
              @if (noteField.touched && depositNote.trim() == '' && isNoteRequired()) {
                <div class="alert alert-danger"
                  >
                  <span>
                    Note is required!
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3"
            (click)="onCancel(); closeModal()">Cancel</button>
            <button type="button" class="btn btn-primary" [disabled]="isSaveDisabled()"
            (click)="onSave(); closeModal()">Save</button>
          </div>
        </div>
      </div>
    </div>
